import React from 'react';

import Trash from 'components/shared/Icon/icons/Trash';

import s from './index.module.css';

type Props = {
  onClick: React.MouseEventHandler<HTMLDivElement>;
};

function DeleteAction({ onClick }: Props) {
  return (
    <div className={s.deleteActionContainer} onClick={onClick}>
      <Trash width="1.8rem" height="1.8rem" />
    </div>
  );
}

export { DeleteAction };
